<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Refund Policy</h2>
                    <ul>
                        <li><a href="https://ewns.in" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Refund Policy</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<section class="blog-area ptb-100">
    <div class="container">
        

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <p>In case you have any issues with the product, the same should be reported during the demo period during business hours. No refund requests will be entertained after purchasing a paid subscription. </p>

                <p>We at EWNS, do not guarantee the following</p>
                <ul style="color: #737b9a;">
                    
                    <li>
                        A specific amount of business
                    </li>
                    <li>
                        A specific position on any search engines within a specific time frame.
                    </li>
                </ul>
                   <p> EWNS is a marketing tool that helps your business get online with just few buttons clicks in matter of minutes, but however in order to get SEO or Digital marketing work well for your business, it would require complex strategies, which tend to work the best with good and relevant content updated regularly.
                    </p>
            </div>
        </div>

        
    </div>
</section>